import { render } from "./EditProduct.vue?vue&type=template&id=cdbd78a6&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=cdbd78a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdbd78a6"]])

export default __exports__